import React from 'react';
import { Table } from 'antd';

export const ComparisonCards = ({ data }) => {
    // Extract titles from comparison_cards
    const titles = data?.comparison_cards?.map((item) => item.title) || [];

    // Get all unique property names (removing values after colon)
    const allProperties = new Set();
    data?.comparison_cards?.forEach((item) => {
        item.content.forEach((detail) => {
            const propertyName = detail.split(':')[0].trim();
            allProperties.add(propertyName);
        });
    });
    const propertiesArray = Array.from(allProperties);

    // Prepare columns
    const columns = [
        {
            title: '',
            dataIndex: 'property',
            key: 'property',
            render: (text) => <strong>{text}</strong>,
        },
        ...titles.map((title, index) => ({
            title: <strong>{title}</strong>,
            dataIndex: title,
            key: title,
            render: (text) => text || '-',
        })),
    ];

    // Prepare data with full values under each title
    const tableData = propertiesArray.map((property, index) => {
        const row = { key: index, property };
        data?.comparison_cards?.forEach((item) => {
            const matchingDetail = item.content.find(
                (detail) => detail.split(':')[0].trim() === property
            );
            row[item.title] = matchingDetail
                ? matchingDetail.split(':')[1]?.trim()
                : '';
        });
        return row;
    });

    return (
        <Table
            columns={columns}
            dataSource={tableData}
            pagination={false}
            bordered
            style={{ width: '100%' }}
        />
    );
};
